import { tsoPqTheme } from '@assets/style/customTsoPqtheme';
import ButtonTsoPq from '@components/Buttons/ButtonTsoPq';
import ChipFilterTsoPq from '@components/Chips/ChipFilterTsoPq';
import TypographyTsoPq from '@components/Typography/TypographyTsoPq';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { Box } from '@mui/material';
import { styled } from '@mui/system';

const createStyledBox = (styles: any) => styled(Box)(() => styles);

export const StyledUploadPage = createStyledBox({
  height: '100%',
  backgroundColor: tsoPqTheme.palette.background.other.color_other_background,
});

export const StyledUploadHeaderWrapper = createStyledBox({
  display: 'flex',
  flexDirection: 'column',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
  marginBottom: tsoPqTheme.spacingValues.componentSpacing.spacing_component_padding_com_padding_m,
  position: 'relative',
});

export const StyledHeaderTitle = createStyledBox({
  fontWeight: '700',
  fontFamily: tsoPqTheme.typography.openSans,
  lineHeight: '2.125rem',
  fontSize: tsoPqTheme.typography.fontsize_title_section_smaller,
  color: tsoPqTheme.palette.customTextColor?.color_font_ft_text,
});

export const StyledUploadSearchSectionWrapper = createStyledBox({
  display: 'flex',
  alignItems: 'center',
  height: '2.125rem',
});
export const StyledUploadFilterSectionWrapper = createStyledBox({
  display: 'flex',
  alignItems: 'center',
  height: '1.625rem',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
});
export const StyledUploadActionsSectionWrapper = createStyledBox({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  height: '2.125rem',
});

export const StyledUploadQuickFiltersWrapper = createStyledBox({
  display: 'flex',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
});

export const StyledUploadPageWrapper = createStyledBox({
  paddingLeft: '3rem',
  paddingRight: '3rem',
  fontSize: '0.75rem',
  paddingTop: `4.625rem`,
  backgroundColor: tsoPqTheme.palette.background.other.color_other_background,
});

export const StyledUploadGridWrapper = createStyledBox({
  height: '85vh',
  width: '100%',
  overflow: 'auto',
});

export const StyledUploadGridTooltip = createStyledBox({
  width: '0.5rem',
  height: '0.5rem',
});

export const StyledUploadStatusRow = createStyledBox({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  gap: '1rem',
  paddingTop: tsoPqTheme.spacingValues.componentSpacing.spacing_component_padding_8,
  paddingBottom: tsoPqTheme.spacingValues.componentSpacing.spacing_component_padding_8,
  marginTop: '0.25rem',
});

export const StyledChipContainer = createStyledBox({
  position: 'relative',
  display: 'flex',
  alignItems: 'center',
});

export const StyledUploadStatusRowDivider = createStyledBox({
  borderRight: `1px solid ${tsoPqTheme.palette.background.neutral.color_neutral_background_bg_ntrl_enabled_lt}`,
  width: '1px',
  position: 'absolute',
  top: '-1rem',
  bottom: '-1rem',
  right: 0,
  left: '2.5rem',
});

export const StyledUploadActionsWrapper = createStyledBox({
  display: 'flex',
  alignItems: 'center',
  aligSelf: 'stretch',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
});

export const StyledUploadTypeCustomHeader = createStyledBox({
  display: 'flex',
  alignItems: 'center',
});

export const StyledUploadTypeCustomHeaderText = createStyledBox({
  display: 'inline-block',
  whiteSpace: 'normal',
  wordBreak: 'break-word',
});

export const StyledUploadTypeCustomHeaderIcon = createStyledBox({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
});

// Detailed view
export const StyledUploadDetailsPage = createStyledBox({
  minHeight: '100vh',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  backgroundColor: tsoPqTheme.palette.background.other.color_other_background,
});
export const StyledUploadDetailsWrapper = createStyledBox({
  display: 'flex',
  flexDirection: 'column',
  minHeight: 'calc(100vh - 6.625rem)',
  width: '74.375rem',
  backgroundColor: tsoPqTheme.palette.background.other.color_other_background_white,
  padding: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24,
  gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_48,
});

export const StyledUploadDetailsPageHeaderWrapper = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24,
  };
});

export const StyledUploadTitleContainer = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_16,
  };
});

export const StyledImportDetailsContainer = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    padding: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_16,
    borderRadius: tsoPqTheme.shape.border_radius_tso_border_radius_4,
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_16,
    background: tsoPqTheme.palette.background.neutral.color_neutral_background_bg_neutral_lt,
  };
});

export const StyledDetailColumnsContainer = styled(Box)(() => {
  return {
    display: 'flex',
    justifyContent: 'space-between',
  };
});

export const StyledDetailColumn = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_4,
  };
});

export const StyledDetailsSection = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_8,
  };
});

export const StyledUploadDetailsSectionWrapper = createStyledBox({
  display: 'flex',
  width: '100%',
  alignItems: 'center',
  justifyContent: 'center',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_4,
});

export const StyledUploadDetailsDetail = createStyledBox({
  display: 'flex',
  flexDirection: 'column',
  width: '25%',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
  flex: '1 0 0',
  padding: '0.75rem 0',
  margin: '1.5rem 0',
  alignSelf: 'stretch',
});

export const StyledUploadDetailTitle = createStyledBox({
  fontFamily: tsoPqTheme.typography.openSans,
  fontSize: '0.75rem',
  color: tsoPqTheme.palette.customTextColor.color_font_ft_helping_text,
  fontStyle: 'normal',
  leadingTrim: 'both',
  textEdge: 'cap',
  fontWeight: '400',
  lineHeight: '1rem',
});

export const StyledUploadDetaiContent = createStyledBox({
  fontFamily: tsoPqTheme.typography.openSans,
  fontSize: '0.875rem',
  color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
  fontStyle: 'normal',
  leadingTrim: 'both',
  textEdge: 'cap',
  fontWeight: '400',
  lineHeight: '1.125rem',
});

export const StyledUploadDetailValidityCheckWrapper = createStyledBox({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  width: '100%',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_12,
  padding: `${tsoPqTheme.spacingValues.pageSpacing.spacing_page_margin_page_margin_xs} 0`,
});

export const StyledUploadDetailTitleWrapper = createStyledBox({
  display: 'flex',
  alignItems: 'center',
  gap: '1.125rem',
  height: '0.75rem',
});

export const StyledUploadDetailValidityCheckTitle = createStyledBox({
  fontFamily: tsoPqTheme.typography.openSans,
  fontSize: '1.125rem',
  color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
  fontStyle: 'normal',
  leadingTrim: 'both',
  textEdge: 'cap',
  fontWeight: '500',
  lineHeight: '1.25rem',
});

export const StyledUploadDetailValidityCheckContentWrapper = createStyledBox({
  display: 'flex',
  gap: '0.5rem',
  minWidth: '100%',
  minHeight: '1.25rem',
  backgroundColor: tsoPqTheme.palette.background.neutral.color_neutral_background_bg_neutral_lt,
  borderRadius: '0.25rem',
});

export const StyledUploadDetailValidityCheckContentIcon = styled(FontAwesomeIcon)({
  diplay: 'flex',
  alignItems: 'center',
  padding: '0.125rem',
  gap: '0.625rem',
  color: tsoPqTheme.palette.customInformation.color_signal_success_success,
});

export const StyledUploadDetailValidityCheckContentText = createStyledBox({
  fontFamily: tsoPqTheme.typography.openSans,
  fontSize: '1rem',
  color: tsoPqTheme.palette.customTextColor.color_font_ft_helping_text,
  fontStyle: 'normal',
  leadingTrim: 'both',
  textEdge: 'cap',
  fontWeight: '400',
  lineHeight: '1.25rem',
});

export const StyledUploadDetailValidityCheckAdditionalContentContainer = createStyledBox({
  display: 'flex',
  gap: '1.125rem',
  alignItems: 'flex-start',
  padding: `${tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_com_gap_xs} 0`,
  fontFamily: tsoPqTheme.typography.openSans,
});

export const StyledUploadDetailValidityCheckAdditionalContentWrapper = createStyledBox({
  display: 'flex',
  flexDirection: 'column',
});

export const StyledUploadDetailValidityCheckAdditionalContentIcon = styled(FontAwesomeIcon)({
  diplay: 'flex',
  padding: '0.125rem',
  alignItems: 'center',
  gap: '0.625rem',
  color: tsoPqTheme.palette.customInformation.color_signal_warning_warning,
});

export const StyledUploadDetailValidityCheckAdditionalContentErrorDetails = createStyledBox({
  display: 'flex',
  flexDirection: 'column',
  width: '100%',
  justifyContent: 'center',
  fontFamily: tsoPqTheme.typography.openSans,
});

export const StyledUploadDetailValidityCheckAdditionalContentErrorDetailsTitle = createStyledBox({
  color: tsoPqTheme.palette.customTextColor.color_font_ft_helping_text,
  fontFamily: tsoPqTheme.typography.openSans,
  fontSize: '0.75rem',
  fontWeight: '400',
  lineHeight: '1rem',
});

export const StyledUploadDetailValidityCheckAdditionalContentErrorDetailsContent = createStyledBox({
  color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
  fontFamily: tsoPqTheme.typography.openSans,
  fontSize: '0.875rem',
  fontWeight: '400',
  lineHeight: '1.125rem',
  fontStyle: 'normal',
  leadingTrim: 'both',
  textEdge: 'cap',
  marginBottom: '0.75rem',
  lineBreak: 'anywhere',
});

// when error with missing device
export const StyledUploadDetailValidityCheckAdditionalContentErrorDetailsMissingWrapper = createStyledBox({
  color: tsoPqTheme.palette.customTextColor.color_font_ft_text,
  fontFamily: tsoPqTheme.typography.openSans,
  display: 'flex',
  minWidth: '100%',
  alignItems: 'flex-start',
  gap: '1.125rem',
  alignSelf: 'stretch',
});
// wrapper with extra details

export const StyledUploadDetailPlausibilityCheckWrapper = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'flex-start',
  alignSelf: 'stretch',
  width: '100%',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_24,
  padding: `${tsoPqTheme.spacingValues.pageSpacing.spacing_page_margin_page_margin_xs} 0`,
});

export const StyledChipFilterTsoPq = styled(ChipFilterTsoPq, {
  shouldForwardProp: (prop) => !['options'].includes(prop as string),
})(({ options }: { options: { background: string; color: string } }) => ({
  height: '1.625rem',
  display: 'flex',
  padding: `${tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_4} ${tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8}`,
  justifyContent: 'center',
  alignItems: 'center',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
  fontFamily: tsoPqTheme.typography.openSans,
  fontSize: tsoPqTheme.typography.fontsize_body_body_small,
  fontWeight: 400,
  lineHeight: tsoPqTheme.typography.fontsize_button_button_medium,
  background: options.background,
  color: options.color,

  '&:hover': {
    background: options.background,
    color: options.color,
    cursor: 'unset',
  },
}));

export const StyledPlausibilityCheckDescription = styled(TypographyTsoPq)({
  color: tsoPqTheme.palette.customTextColor.color_neutral_font_ft_nrtrl_enabled,
  fontFamily: tsoPqTheme.typography.openSans,
});

export const StyledDataGridContainer = styled(Box)({
  width: '68.5rem',
  display: 'flex',
  flexDirection: 'column',
  gap: tsoPqTheme.spacingValues.pageSpacing.spacing_page_gap_24,
});

export const StyledButtonContainer = styled(Box)({
  display: 'flex',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_12,
  justifyContent: 'flex-end',
});

export const StyledCheckboxWrapper = styled(Box)({
  width: '100%',
  display: 'flex',
  justifyContent: 'space-around',
});

export const StyledPlausibilityCheckHeader = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_16,
});

export const AccordionContentWrapper = styled(Box)(() => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: 'column',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
    justifyContent: 'flex-start',
  };
});

export const StyledButtonTsoPq = styled(ButtonTsoPq)(() => {
  return {
    width: 'fit-content',
    alignSelf: 'flex-end',
  };
});

interface ValidityCheckDetailsContainerProps {
  isRow?: boolean;
}
export const ValidityCheckDetailsContainer = styled(Box, {
  shouldForwardProp: (prop) => prop !== 'isRow',
})<ValidityCheckDetailsContainerProps>(({ isRow }) => {
  return {
    width: '100%',
    display: 'flex',
    flexDirection: isRow ? 'row' : 'column',
    justifyContent: isRow ? 'flex-end' : 'flex-start',
    gap: isRow ? '2.5rem' : tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_8,
    alignItems: isRow ? 'flex-end' : 'flex-start',
  };
});

export const StyledBoxContainerButtons = styled(Box)(() => {
  return {
    display: 'flex',
    justifyContent: 'flex-end',
    width: '100%',
    gap: tsoPqTheme.spacingValues.componentSpacing.spacing_component_gap_16,
  };
});

export const StyledBoxContainer = styled(Box)(() => {
  return {
    display: 'flex',
    flexDirection: 'column',
  };
});
